import React from 'react';
import { useTranslation } from '../../../../contexts/LanguageContext';

const MobileConfirmationModal = ({ 
  isOpen, 
  onCancel, 
  onConfirm, 
  title, 
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "red"
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modal}>
        {title && <h3 className="font-semibold text-lg mb-2">{title}</h3>}
        <p className="mb-4">{message}</p>
        <div style={styles.modalButtons}>
          <button 
            onClick={onConfirm} 
            style={{ ...styles.confirmButton, backgroundColor: confirmColor }}
          >
            {confirmText}
          </button>
          <button 
            onClick={onCancel} 
            style={styles.cancelButton}
          >
            {cancelText || t('sharesubs.actions.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    backdropFilter: "blur(2px)",
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    zIndex: 1001,
    minWidth: "300px",
    maxWidth: "90%",
  },
  modalButtons: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "20px",
  },
  confirmButton: {
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "500",
  },
  cancelButton: {
    backgroundColor: "#ccc",
    color: "#000",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "500",
  },
};

export default MobileConfirmationModal;